/*
 * FilthyBass — product story gallery.
 *
 * Cross-fades the approved lifestyle shots. Every slide is already in the DOM;
 * this only moves an `is-active` class, so nothing loads late and nothing
 * reflows.
 *
 * Deliberately quiet:
 *  - respects prefers-reduced-motion by never starting
 *  - pauses when scrolled out of view, so a PDP left open in a tab is not
 *    animating forever
 *  - pauses on hover, so a shopper studying a print is not interrupted
 */
if (!customElements.get('fb-story-gallery')) {
  class FBStoryGallery extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.fb-story__slide'));
      if (this.slides.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.index = 0;
      this.delay = (Number(this.dataset.interval) || 5) * 1000;
      this.visible = true;

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.start();
          else this.stop();
        }, { threshold: 0.2 });
        this.observer.observe(this);
      } else {
        this.start();
      }
    }

    disconnectedCallback() {
      this.stop();
      if (this.observer) this.observer.disconnect();
    }

    start() {
      if (this.timer || !this.visible) return;
      this.timer = setInterval(() => this.advance(), this.delay);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    advance() {
      const previous = this.slides[this.index];
      this.index = (this.index + 1) % this.slides.length;
      const next = this.slides[this.index];
      previous.classList.remove('is-active');
      previous.setAttribute('aria-hidden', 'true');
      next.classList.add('is-active');
      next.removeAttribute('aria-hidden');
    }
  }

  customElements.define('fb-story-gallery', FBStoryGallery);
}
